export enum TreeFileType {
    Folder = 0,
    TeX = 1
}